// src/utils/authStorage.js

const STORAGE_KEY = "userData";

/**
 * Save user data (e.g., token, user info) to localStorage
 * @param {Object} data - The user data to store
 */
export const saveUserData = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving user data:", error);
  }
};

/**
 * Get saved user data from localStorage
 * @returns {Object|null} - Parsed user data or null if not found
 */
export const getUserData = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};

/**
 * Remove user data from localStorage (logout)
 */
export const clearUserData = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing user data:", error);
  }
};

/**
 * Check if user is logged in
 * @returns {boolean}
 */
export const isLoggedIn = () => {
  const user = getUserData();
  return !!user && !!user.token; // or any property you use to mark logged in
};
